import React, { useEffect, useState } from 'react';

import { useHelpBundle } from '@plasma/ui.application.app';
import { useResourceBundle, useTranslation } from '@plasma/ui.utils.i18n';

import translations from './i18n';
import { EquipmentMasterProps } from './equipment-master';
import help from './equipment-master.help';
import { fetchAllDataGet_byApiName } from '../../services/gets/getdata';
import { sendAllDataPost_byApiNameAndData } from '../../services/posts/postdata';
import notification from '@plasma/ui.feedback.notification';

import equipmentMasterColumns from '../../types/equpimentMasterdatatype';
import { deleteDataFromApiWithBody } from '../../services/Deletes/deleteData';
import { apiUriMasterDataHttp } from '../../services/conf/apiConf';

function useEquipmentMasterHook(props: EquipmentMasterProps) {
  useResourceBundle(translations, undefined, 'a4b4fa4a-5580-4909-b567-a34e9315465e');
  useHelpBundle(help);
  const { t } = useTranslation();

  const [dataForColumns, setdataForColumns] = useState([]);
 // const [convertedDataForColumns, setconvertedDataForColumns] = useState([]);
  const [columnNames, setcolumnNames] = useState(equipmentMasterColumns());
  const [finalColumns, setFinalColumns] = useState([]);

  //const [hiddenColumns] = useState(['remarks']);

  useEffect (() => {
      fetchAllDataGet_byApiName("GetMasterEquipments", apiUriMasterDataHttp()).then((data) => {
        console.log(data);
        setdataForColumns(data);
      }).catch((error)=>{
        console.log("Failed to Fetch equipments");
      });
  },[]);

  //console.log(convertedDataForColumns);

  // useEffect(() => {
  //   const columnsAfterAddingOptions = columnNames.map((item)=> {
  //     if (item.accessor === 'isactive'){
  //       item.options =  [{display: 'ACTIVE', value: 'true'}, {display: 'INACTIVE', value: 'false'}] || [];
  //     }
  //     return(item);
  //   })
  //   setFinalColumns(columnsAfterAddingOptions);

  //   const modifiedJsonArray = dataForColumns?.map(item => {
  //     return {
  //         ...item,
  //         isactive: item.isactive ? "ACTIVE" : "INACTIVE"
  //       };
  //   });
  //   setconvertedDataForColumns(modifiedJsonArray);
  //   //console.log("column: ",columnsAfterAddingOptions);
  // },[dataForColumns]);

  const handleSaveAndDeleteFromTable = async(data, returnType,index) =>{

    if (returnType === 'delete'){
      //console.log("DELETE");
      deleteDataFromApiWithBody('DeleteEquipments', data, apiUriMasterDataHttp()).then((response) => {
        //console.log(response);
        if(response){
          fetchAllDataGet_byApiName("GetMasterEquipments", apiUriMasterDataHttp()).then((data) => {
            setdataForColumns(data);
            notification.success('Removed !', 'Data Deleted Permanently', undefined, 'medium', 3)
          }).catch((error)=>{
            console.log("Failed to EditPlantLayout");
          });
        }
      })
    }
    else{

      if (data.displayseq === ''){
        data.displayseq = (index+1);
        }

      data.displayseq = parseFloat(data.displayseq);


      if (data.isactive === '' ) {
        data.isactive = false ;
        }

      //console.log(data,returnType,index);


      sendAllDataPost_byApiNameAndData('AddMasterEquipment', data, apiUriMasterDataHttp())
        .then((response) => {

          if(response){
            fetchAllDataGet_byApiName("GetMasterEquipments", apiUriMasterDataHttp()).then((data) => {
              setdataForColumns(data);
              notification.success('Success !', 'Data Saved Successfully', undefined, 'medium', 3)
            }).catch((error)=>{
              console.log("Failed to EditPlantLayout");
            });
          }
        });

    }
  };


  return {
    t,
    dataForColumns,
    columnNames,
    handleSaveAndDeleteFromTable
  };
}

export default useEquipmentMasterHook;
